import defaultAppConfigPropTypes from '../app/default-app-prop-types';
import FirebaseRepository from './FirebaseRepository';
import firebaseRoutes from './firebase-routes';
import firebaseDrawerRoutes from './firebase-drawer-routes';
import firebaseEnMessages from './firebase-en.json';
import firebaseIdMessages from './firebase-id.json';

const firebaseAppConfig = {
  ...defaultAppConfigPropTypes,
  intlExtraMessageLocales: {
    en: [
      firebaseEnMessages,
    ],
    id: [
      firebaseIdMessages,
    ],
  },

  AuthenticationRepository: FirebaseRepository,
  applicationName: 'firebase-rs',
  commonComponentProps: {
    ...defaultAppConfigPropTypes.commonComponentProps,
    applicationName: 'firebase-rs',
    drawerRoutes: firebaseDrawerRoutes,
    AuthenticationRepository: FirebaseRepository,
  },

  appRoutes: firebaseRoutes,

  firebaseConfig: {
    apiKey: 'AIzaSyDrke6yZ-jh2gxX3_PILFQH9hk3ZgIL_zY',
    authDomain: 'freesia-92a2d.firebaseapp.com',
    databaseURL: 'https://freesia-92a2d.firebaseio.com',
    projectId: 'freesia-92a2d',
    storageBucket: 'freesia-92a2d.appspot.com',
    messagingSenderId: '1092489740861',
    appId: '1:1092489740861:web:d0f55f098d1b415a04e054',
  },
};

export default firebaseAppConfig;
